<div class="login_wrapper" *ngIf="!azureAuthFlag">
  <div class="bg_icon">
   <div class="humidity"></div>
   <div class="fan"></div>
   <div class="bulp"></div>
   <div class="air_volume"></div>
  </div>
  <div class="login_container">
    <div class="login_card col-8 col-md-5 col-lg-5 col-xl-4 col-xxl-5">
          <div class="d-flex justify-content-center flex-column align-items-center">
              <div class="logocus"></div>
              <div class="logoTCS"></div>
          </div>
          <form class="login_form d-flex flex-column align-items-center" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="form-group w-100">
                  <label for="userName">User Name</label>
                  <input type="text" class="form-control" id="userName" placeholder="Enter Username" 
                  [ngClass]="{ 'is-invalid': submitted && loginFormControl.userName.errors }" formControlName="userName" />
                  <div class="text-danger" *ngIf="(loginFormControl.userName.touched && submitted) && loginFormControl.userName.errors?.required">
                    <p>User Name is required</p>
                  </div>
              </div>
              <div class="form-group w-100">
                  <label for="password">Password</label>
                  <input type="password" class="form-control" id="password" placeholder="Password"
                  [ngClass]="{ 'is-invalid': submitted && loginFormControl.password.errors }" formControlName="password" />
                  <div class="text-danger" *ngIf="(loginFormControl.password.touched && submitted) && loginFormControl.password.errors?.required">
                    <p>Password is required</p>
                  </div>
              </div>
              <div class="text-danger text-start" *ngIf="error">
                <h3>{{error}}</h3> 
              </div>
              <div class="form-group text-center">
                  <button type="submit" class="cstm_btn_css blue_btn">LOGIN</button>
              </div>
              <div class="form-group text-center">
                  <a routerLink="" class="forget_passwaord_btn">FORGOT PASSWORD?</a>
              </div>
          </form>
      </div>
  </div>
  <footer class="footer">
    <p class="copyright">Copyright © 2022 | TCS Clever Energy<sup>TM</sup>. All Right Reserved.</p>
  </footer>
</div>
